import type { ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import styles from './ReservationBoardCalendar.module.css';

type ReservationFormLabelProps = {
  label: string;
  t: (key: string, options?: { defaultValue?: string }) => string;
  /** 任意欄だけマーク。必須は HTML required / 登録バーで分かるのでバッジは出さない */
  optional?: boolean;
  /** ラベル行右端の補助（例: 枠時間）。縦スペースを増やさない */
  meta?: ReactNode;
};

export default function ReservationFormLabel({
  label,
  t,
  optional = false,
  meta,
}: ReservationFormLabelProps) {
  return (
    <Form.Label className={`${styles.formFieldLabel} d-inline-flex align-items-center gap-1 mb-1`}>
      <span className={styles.formFieldLabelMain}>
        {label}
        {optional ? (
          <span className={styles.fieldOptionalMark}>
            {t('reservation.board.fieldOptional', { defaultValue: '任意' })}
          </span>
        ) : null}
      </span>
      {meta ? (
        <span className={styles.formFieldLabelMeta} aria-live="polite">
          {meta}
        </span>
      ) : null}
    </Form.Label>
  );
}
